export const getFirstDayAndCurrentDateOfCurrentMonth = () => {
  const currentDay = new Date();

  const firstDayOfCurrentMonth = new Date(
    currentDay.getFullYear(),
    currentDay.getMonth(),
    1
  );

  return {
    firstDay: firstDayOfCurrentMonth,
    currentDay: currentDay,
  };
};
